import type { BookingDetailsState } from '../../domain/types'
import { format, isValid, parse } from 'date-fns'

interface FormattedVisitingHour {
  date: string
  startTime: string
  endTime: string
}

export interface FormattedVisitingHoursGroup {
  name: string
  location: string
  visitingHours: FormattedVisitingHour[]
}

function formatTimeHHMM(time: string): string {
  if (!time)
    return ''
  const parsed = parse(time, 'HH:mm:ss', new Date())
  return isValid(parsed) ? format(parsed, 'HH:mm') : time
}

function normalizeForComparison(value: string): string {
  return value.trim().toLowerCase()
}

function getVisitingHoursGroupKey(name: string, location: string): string {
  return `${normalizeForComparison(name)}|${normalizeForComparison(location)}`
}

export function getFormattedVisitingHours(state: BookingDetailsState): FormattedVisitingHoursGroup[] {
  const visitingHours = state.travelGuideContactInfo?.visitingHours ?? []
  const groups = new Map<string, FormattedVisitingHoursGroup>()

  for (const visitingHour of visitingHours) {
    const groupKey = getVisitingHoursGroupKey(visitingHour.name, visitingHour.location)
    const formattedVisitingHour = {
      date: visitingHour.date,
      startTime: formatTimeHHMM(visitingHour.startTime),
      endTime: formatTimeHHMM(visitingHour.endTime),
    }
    const group = groups.get(groupKey)

    if (group) {
      group.visitingHours.push(formattedVisitingHour)
      continue
    }

    groups.set(groupKey, {
      name: visitingHour.name,
      location: visitingHour.location,
      visitingHours: [formattedVisitingHour],
    })
  }

  return Array.from(groups.values())
}
